import { snacksTypes } from "./snacksTypes";

const initialState = {
    burgers : 0,
    burgerPrice : 0,
    fries : 0,
    friesPrice : 0,
    wraps : 0,
    wrapsPrice : 0,
    pizzas : 0,
    pizzasPrice : 0,
    snackItems : 0
}

export const snacksReducer = (state = initialState, action) => {
    switch(action.type) {
        case snacksTypes.BURGER_TYPE_INCREASE : {
            return {...state, burgers : state.burgers + 1, burgerPrice : state.burgerPrice + action.payload, snackItems : state.snackItems + 1}
        }
        case snacksTypes.BURGER_TYPE_DECREASE : {
            return {...state, burgers : state.burgers - 1, burgerPrice : state.burgerPrice - action.payload, snackItems : state.snackItems - 1}
        }
        case snacksTypes.FRIES_TYPE_INCREASE : {
            return {...state, fries : state.fries + 1, friesPrice: state.friesPrice + action.payload, snackItems : state.snackItems + 1}
        }
        case snacksTypes.FRIES_TYPE_DECREASE : {
            return {...state, fries : state.fries - 1, friesPrice: state.friesPrice - action.payload, snackItems : state.snackItems - 1}
        }
        case snacksTypes.WRAP_TYPE_INCREASE: {
            return {...state, wraps : state.wraps + 1, wrapsPrice: state.wrapsPrice + action.payload, snackItems : state.snackItems + 1}
        }
        case snacksTypes.WRAP_TYPE_DECREASE : {
            return {...state, wraps : state.wraps - 1, wrapsPrice: state.wrapsPrice - action.payload, snackItems : state.snackItems - 1}
        }
        case snacksTypes.PIZZA_TYPE_INCREASE: {
            return {...state, pizzas : state.pizzas + 1, pizzasPrice: state.pizzasPrice + action.payload, snackItems : state.snackItems + 1}
        }
        case snacksTypes.PIZZA_TYPE_DECREASE : {
            return {...state, pizzas : state.pizzas - 1, pizzasPrice: state.pizzasPrice - action.payload, snackItems : state.snackItems - 1}
        }
        case snacksTypes.CLEAR_ALL_SNACKS : {
            return initialState
        }
        default : return state
    }
}